import React, { Component } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Input, Button } from "mdbreact";
import domain from ".././../../../domain";
import { Row, Col, Card, CardBody } from "mdbreact";
const moment = require("moment");

let enumerateDaysBetweenDates = function (startDate, endDate) {
  var dates = [];

  var currDate = moment(startDate).startOf("day");
  var lastDate = moment(endDate).startOf("day");

  dates.push(currDate.toDate());
  while (currDate.add(1, "days").diff(lastDate) <= 0) {
    dates.push(currDate.clone().toDate());
  }

  return dates;
};
export default class EditSession extends Component {
  constructor(props) {
    super(props);
    this.state = {
      course_session_id: "",
      course_id: "",
      session_date: "",
      start_time: "",
      end_time: "",
      lname: "",
      topic: "",
      session_data: null,
      course_data: null,
      course_name: "",
    };
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
    console.log(e.target.name + "" + e.target.value);
  };
  componentDidMount() {
    this.getSessionDetails();
  }
  async checkTimes(id) {
    console.log(id);
    let r = false;
    let submitted_start_time = this.state.start_time;
    let submitted_end_time = this.state.end_time;
    console.log(submitted_end_time === submitted_start_time);

    const result = await axios.get(
      `${domain.DBServer}/fetch-sessions-by-date/${id}`
    );
    console.log(result.data);
    if (result.data != null) {
      r = result.data.some((data) => {
        let format = "hh:mm:ss";
        let beginningTime = moment(data.start_time, format);
        let endingTime = moment(data.end_time, format);
        let submitted_start_time = moment(this.state.start_time, format);
        let submitted_end_time = moment(this.state.end_time, format);
        let db_date = moment(data.session_date)
          .tz("Asia/Calcutta")
          .format("MM-DD-YYYY");
        let state_date = this.state.session_date;

        if (
          state_date === db_date &&
          data.start_time === this.state.start_time &&
          this.state.end_time === data.end_time
        ) {
          return false;
        }

        if (
          submitted_start_time.isBetween(
            beginningTime,
            endingTime,
            null,
            "[)"
          ) ||
          submitted_end_time.isBetween(beginningTime, endingTime, null, "(]")
        ) {
          return true;
        }

        // return true
      });
    }
    return r;
  }

  getSessionDetails = () => {
    let sessionId = this.props.match.params.id;
    axios
      .all([
        axios.get(`${domain.DBServer}/fetch-course-session/${sessionId}`),
        axios.get(`${domain.DBServer}/fetch-session/${sessionId}`),
      ])
      .then(
        axios.spread((course, session) => {
          console.log(session.data);
          console.log(course.data);
          if (session.data) {
            this.setState({
              session_data: session.data,
              course_session_id: session.data[0].course_session_id,
              start_time: session.data[0].start_time,
              end_time: session.data[0].end_time,
              topic: session.data[0].title,
              lname: session.data[0].lecturer_name,
              session_date: moment(session.data[0].session_date)
                .tz("Asia/Calcutta")
                .format("MM-DD-YYYY"),
            });
          }
          if (course.data) {
            this.setState({
              course_data: course.data,
              course_name: course.data[0].title,
              course_id: course.data[0].course_id,
            });
          }
        })
      )
      .catch((error) => {
        console.log(error);
      });
  };

  editSession(newSession) {
    console.log(newSession);
    let sessionId = this.props.match.params.id;
    axios
      .request({
        method: "PUT",
        url: `${domain.DBServer}/edit-session/${sessionId}`,
        data: newSession,
      })
      .then((response) => {
        if (response.data === 1) {
          alert("Details are updated Successfully");
          this.props.history.push(`/view-schedules/${this.state.course_id}`);
        } else {
          alert("Details are not updated");
        }
      })
      .catch((err) => console.log(err));
  }

  async onSubmit(e) {
    e.preventDefault();

    const newSession = {
      course_id: this.state.course_id,
      session_date: this.state.session_date,
      start_time: this.state.start_time,
      end_time: this.state.end_time,
      topic: this.state.topic,
      lname: this.state.lname,
    };
    let start_time = moment(this.state.start_time, "hh:mm:ss a");
    let end_time = moment(this.state.end_time, "hh:mm:ss a");
    let diff = end_time.diff(start_time, "hours");
    if (diff < 0) {
      alert(
        "You have selected wrong timings( End time is less than Start Time)"
      );
      return false;
    }

    let s = await this.checkTimes(this.state.session_date);
    console.log(s);
    let r = window.confirm("Check once again the details before submitting");
    if (r) {
      if (s === true) {
        alert(
          "The session you have entered  overlaps with already existing sessions"
        );
        return false;
      } else {
        this.editSession(newSession);
      }
    } else {
      return false;
    }
  }

  render() {
    let result, options;
    if (this.state.course_data) {
      let startd = moment(this.state.course_data[0].start_date).format(
        "MM/DD/YYYY"
      );
      let endd = moment(this.state.course_data[0].end_date).format(
        "MM/DD/YYYY"
      );
      result = enumerateDaysBetweenDates(startd, endd);
      if (result) {
        options = result.map((dates, key) => {
          return (
            <option
              key={key}
              value={moment(dates).tz("Asia/Calcutta").format("MM-DD-YYYY")}
            >
              {moment(dates).tz("Asia/Calcutta").format("MM-DD-YYYY")}
            </option>
          );
        });
      }
    }
    return (
      <div>
        <br />
        <Row className="justify-content-md-center">
          <Col md="6">
            <Card>
              <CardBody>
                <Link
                  className="btn grey"
                  to={`/view-schedules/${this.state.course_id}`}
                >
                  Back
                </Link>
                <form onSubmit={this.onSubmit.bind(this)}>
                  <div className="form-group">
                    <label>Course Name</label>

                    <Input
                      className="form-control"
                      id="course"
                      name="course"
                      value={this.state.course_name}
                      autoFocus
                      required
                    ></Input>
                    <Input
                      type="hidden"
                      name="course_id"
                      value={this.state.course_id}
                    />
                  </div>
                  <div className="form-group">
                    <label>Date</label>
                    <select
                      className="form-control"
                      id="date"
                      name="session_date"
                      onChange={this.handleInputChange}
                      required
                      value={moment(this.state.session_date)
                        .tz("Asia/Calcutta")
                        .format("MM-DD-YYYY")}
                      selected={moment(this.state.session_date)
                        .tz("Asia/Calcutta")
                        .format("MM-DD-YYYY")}
                    >
                      {options}
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Start Time</label>

                    <Input
                      id="start_time"
                      type="time"
                      name="start_time"
                      min="09:00AM"
                      max="05:00PM"
                      value={this.state.start_time}
                      required
                      onChange={this.handleInputChange}
                    />
                    <span className="validity"></span>
                  </div>
                  <div className="form-group">
                    <label>End Time</label>
                    <Input
                      id="end_time"
                      type="time"
                      name="end_time"
                      min="09:00AM"
                      max="05:00PM"
                      value={this.state.end_time}
                      required
                      onChange={this.handleInputChange}
                    />
                    <span className="validity"></span>
                  </div>
                  {/* <div className="form-group">
      <label>End Time</label>
      <input type="time" name="end_time" onChange={this.handleInputChange} value={this.state.end_time}/>
    </div>
    */}
                  {/* <Input type="date" value={this.state.date} label="Date" name="date" onChange={this.handleInputChange} pattern="[0-9]{0,1}/[0-9]{0,1}/[0-9]{4}" validate required /> */}
                  <Input
                    type="text"
                    value={this.state.topic}
                    label="Topic"
                    name="topic"
                    id="topic"
                    onChange={this.handleInputChange}
                    validate
                    required
                  />
                  <Input
                    type="text"
                    label="Lecturer Name"
                    value={this.state.lname}
                    name="lname"
                    id="lname"
                    onChange={this.handleInputChange}
                    validate
                    required
                  />
                  <Button type="submit">Submit</Button> &nbsp;&nbsp;
                  {/* <Button type="reset" name="clear" onClick={this.intialValues} >Clear Values</Button> */}
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}
